import { StateModel } from '../../shared/models/default-state.model';
import {
  IMPORT_TRAINING_DATASET_REQUEST,
  IMPORT_TRAINING_DATASET_SUCCESS,
  IMPORT_TRAINING_DATASET_ERROR,
  TRAINING_DATASET_CLEAR_ERROR,
} from '../actions/dataset.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: [],
};

export const trainingDatasetReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case IMPORT_TRAINING_DATASET_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case IMPORT_TRAINING_DATASET_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };

    case IMPORT_TRAINING_DATASET_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case TRAINING_DATASET_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default trainingDatasetReducer;
